<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Título" :required="true" v-model="form.titulo"
						:value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="data"> Data</label>
						<div class="col-sm-9">
							<the-mask class="col-xs-10 col-sm-3" type="text" name="usuario" :mask="['##/##/####']"
								v-model="form.data" placeholder="data" required v-debounce:1000ms="isValidDateFormatDDMMYYYY" :masked="true"></the-mask>
							<span class="text-red-500 ml-2 pl-2" v-if="checkData && !validadeData">Data inválida</span>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Imagem</label>
						<div class="col-sm-5">
							<file-upload v-if="!allImages.length" ref="fuploadImage" :url="'/v1/governanca-e-gestao/upload'" :id="null"
								:label="'PNG, JPG, GIF até 10 MB'" :multiple="false"></file-upload>
							<items-edit v-else :files="allImages"
								url="/v1/governanca-e-gestao/upload" id="id"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Arquivo</label>
						<div class="col-sm-5">
							<file-upload v-if="!allFiles.length" ref="fuploadFile" :url="'/v1/governanca-e-gestao/upload/file'" :id="null"
								:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
								:isFile="true"></file-upload>
							<items-edit v-else :files="allFiles" url="/v1/governanca-e-gestao/upload/file" id="id"
								:isFile="true"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="tipo"> Tipo </label>
						<div class="col-sm-5">
							<select class="form-control" v-model="form.tipo" required>
								<option value="">Selecione</option>
								<option :value="d.id" v-for="(d, k) in selectTipo" :key="k" :selected="d.id == form.tipo">{{ d.titulo }}</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import { TheMask } from 'vue-the-mask'
import moment from 'moment'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
		TheMask
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Governança e Gestão',
			form: {
				titulo: '',
				data: '',
				tipo: '',
				ativo: '1',
			},
			allImages: [],
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
			validadeData: false,
			checkData: false,
			selectTipo: [{
				id: 1,
				titulo: 'Capa'
			},{
				id: 2,
				titulo: 'E-books'
			}]
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				let resp = await req(`/v1/governanca-e-gestao/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				if (!this.allImages.length) {
					this.isActive = false
					const tb = this.$refs.fuploadImage.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				if (!this.allFiles.length) {
					this.isActive = false
					const tbm = this.$refs.fuploadFile.$children.filter(i => i.$refs.tb)
					const mm = tbm[0]
					await mm.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/governanca-e-gestao')
			} else {
				let resp = await req('/v1/governanca-e-gestao', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fuploadImage.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				const tbm = this.$refs.fuploadFile.$children.filter(i => i.$refs.tb)
				const mm = tbm[0]
				await mm.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/governanca-e-gestao')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			await req('/versao/1', 'put', {
				title: Date.now()
			})
		},
		isValidDateFormatDDMMYYYY(inputDate) {
			var date_regex = /^(?:(?:31(\/)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[9-9]|[2-9]\d)?\d{2})$/
			this.checkData = true
			this.validadeData = date_regex.test(inputDate)
		},
		getDados() {
			req(`/v1/governanca-e-gestao/${this.$route.params.id}`).then(resp => {
				this.form.ativo = resp.ativo
				this.form.titulo = resp.titulo
				this.form.tipo = resp.tipo
				this.form.data = moment(new Date(`${resp.data} `)).format('DD/MM/YYYY')
				this.allImages = resp.imagem ? [{ id: this.$route.params.id, images: resp.imagem }] : ''
				this.allFiles = resp.arquivo ? [{ id: this.$route.params.id, files: resp.arquivo }] : ''
				this.isActive = false
			}).catch(() => {
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
